import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import type { RowFilters } from "@/services/tax-closing";
import {
  SITUATION_DEFAULT,
  SITUATION_QUERY_KEY,
  situationToFilters,
} from "./situation-filter";
import { updateSearchParam } from "./update-search-param";

interface SituationFilterState {
  situation: string;
  filters: RowFilters;
  setSituation: (value: string) => void;
}

export function useSituationFilter(): SituationFilterState {
  const [searchParams, setSearchParams] = useSearchParams();
  const situation = searchParams.get(SITUATION_QUERY_KEY) || SITUATION_DEFAULT;
  const filters = useMemo(() => situationToFilters(situation), [situation]);

  const setSituation = useCallback(
    (value: string): void => {
      updateSearchParam(setSearchParams, SITUATION_QUERY_KEY, value);
    },
    [setSearchParams],
  );

  return { situation, filters, setSituation };
}
